var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled from "styled-components";
import _ from "lodash";
import { setActiveLanguage } from "../../i18n";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { getAppThemeName } from "../../../services/appTheme";
const StyledInputWrapper = styled.div `
  position: relative;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const StyledInput = styled.input `
  position: absolute;
  height: 7px;
  width: 6px;
  outline: none;
  top: 8px;
  left: 3px;
  margin: 0;
  opacity: 0;

  &:checked + label {
    color: ${props => props.theme.primary};

    &:before {
      border-color: ${props => props.theme.primary};
    }

    &:after {
      opacity: 1;
    }
  }
`;
const StyledLabel = styled.label `
  display: flex;
  align-items: center;
  transition: color 0.2s ease-in-out;
  font-weight: ${props => props.appTheme === "invoned" ? 400 : 600};
  vertical-align: middle;
  color: ${props => props.theme.tertiary};
  cursor: pointer;
  user-select: none;

  @media only screen and (min-width: 768px) {
    flex-direction: ${props => (props.inline ? "row" : "column")};
  }

  &:before {
    transition: border-color 0.2s ease-in-out;
    position: absolute;
    content: "";
    width: 12px;
    height: 12px;
    left: 0;
    top: 6px;
    border-radius: 50%;
    z-index: 1;
  }

  &:after {
    transition: opacity 0.2s ease-in-out;
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    left: 3px;
    top: 9px;
    border-radius: 50%;
    opacity: 0;
    z-index: 2;
  }
`;
const StyledImage = styled.img `
  width: 28px;
  height: 28px;
  margin-right: 15px;
  margin-bottom: 0;

  @media only screen and (min-width: 768px) {
    width: ${props => (props.inline ? "28px" : "34px")};
    height: ${props => (props.inline ? "28px" : "34px")};
    margin-right: ${props => (props.inline ? "15px" : "0")};
    margin-bottom: ${props => (props.inline ? "0" : "10px")};
  }
`;
const LanguageOption = (_a) => {
    var { label, value, name, checked, className, image, inline = false } = _a, restProps = __rest(_a, ["label", "value", "name", "checked", "className", "image", "inline"]);
    const { t } = useTranslation();
    const [fid] = useState(restProps.id || _.uniqueId("field-"));
    const onChange = (e) => {
        setActiveLanguage(e.currentTarget.value).then();
        if (restProps.onChange) {
            restProps.onChange(e);
        }
    };
    const appTheme = getAppThemeName();
    return (React.createElement(StyledInputWrapper, { className: className },
        React.createElement(StyledInput, Object.assign({ type: "radio", name: name, id: fid, value: value, checked: i18next.language === value, onChange: onChange }, restProps)),
        React.createElement(StyledLabel, { htmlFor: fid, inline: inline, appTheme: appTheme },
            React.createElement(StyledImage, { src: image, decoding: "async", loading: "lazy", alt: t("language.image_alt", {
                    language_translated: t(`language.${value}`),
                }), inline: inline }),
            label)));
};
export default LanguageOption;
